(() => {
  if (window.vantoxOffersInitialized) return;
  window.vantoxOffersInitialized = true;

  function initialize(root) {
    const sections = [];

    if (root.matches?.("[data-vp-offers]")) {
      sections.push(root);
    }

    root.querySelectorAll?.("[data-vp-offers]").forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      if (section.dataset.vpInitialized === "true") return;

      const form = section.querySelector("form");
      const button = section.querySelector("[data-vp-button]");

      if (!form || !button) return;

      section.dataset.vpInitialized = "true";

      const update = () => {
        const selected = form.querySelector(
          ".vp-offers__radio:checked:not(:disabled)"
        );

        button.disabled = !selected;
        button.textContent = selected
          ? button.dataset.ready
          : button.dataset.unavailable;
      };

      form.addEventListener("change", update);
      update();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initialize(document),
      { once: true }
    );
  } else {
    initialize(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialize(event.target);
  });
})();
(() => {
  if (customElements.get("vantox-gallery-auto")) return;

  class VantoxGalleryAuto extends HTMLElement {
    connectedCallback() {
      this.slides = [
        ...this.querySelectorAll("[data-gallery-slide]")
      ];

      this.thumbnails = [
        ...this.querySelectorAll("[data-gallery-thumbnail]")
      ];

      this.pauseButton = this.querySelector("[data-gallery-pause]");
      this.index = 0;

      this.paused = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;

      this.hovered = false;
      this.focused = false;

      this.events = new AbortController();
      const options = { signal: this.events.signal };

      this.addEventListener("click", (event) => {
        const thumbnail = event.target.closest(
          "[data-gallery-thumbnail]"
        );

        if (thumbnail && this.contains(thumbnail)) {
          this.show(Number(thumbnail.dataset.index));
          this.restart();
        }

        if (event.target.closest("[data-gallery-pause]")) {
          this.paused = !this.paused;
          this.updatePauseButton();
          this.restart();
        }
      }, options);

      this.addEventListener("pointerenter", (event) => {
        if (event.pointerType !== "mouse") return;

        this.hovered = true;
        this.stop();
      }, options);

      this.addEventListener("pointerleave", (event) => {
        if (event.pointerType !== "mouse") return;

        this.hovered = false;
        this.restart();
      }, options);

      this.addEventListener("focusin", () => {
        this.focused = true;
        this.stop();
      }, options);

      this.addEventListener("focusout", (event) => {
        if (this.contains(event.relatedTarget)) return;

        this.focused = false;
        this.restart();
      }, options);

      document.addEventListener("visibilitychange", () => {
        this.restart();
      }, options);

      this.updatePauseButton();
      this.restart();
    }

    disconnectedCallback() {
      this.stop();
      this.events?.abort();
    }

    show(index) {
      if (!Number.isInteger(index) || !this.slides[index]) return;

      this.index = index;

      this.slides.forEach((slide, position) => {
        slide.hidden = position !== index;
      });

      this.thumbnails.forEach((thumbnail, position) => {
        thumbnail.setAttribute(
          "aria-pressed",
          String(position === index)
        );
      });
    }

    updatePauseButton() {
      if (!this.pauseButton) return;

      this.pauseButton.textContent = this.paused
        ? this.pauseButton.dataset.playLabel
        : this.pauseButton.dataset.pauseLabel;

      this.pauseButton.setAttribute(
        "aria-pressed",
        String(this.paused)
      );
    }

    stop() {
      window.clearInterval(this.timer);
    }

    restart() {
      this.stop();

      if (
        this.dataset.autoplay !== "true" ||
        this.paused ||
        this.hovered ||
        this.focused ||
        document.hidden ||
        this.slides.length < 2
      ) return;

      const seconds = Math.max(
        3,
        Number(this.dataset.seconds) || 5
      );

      this.timer = window.setInterval(() => {
        this.show((this.index + 1) % this.slides.length);
      }, seconds * 1000);
    }
  }

  customElements.define(
    "vantox-gallery-auto",
    VantoxGalleryAuto
  );
})();